<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">Reenviar Ingressos</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div class="box-content">
        <form @submit.prevent class="form">
          <div style="display: flex; align-items: center">
            <div style="position: relative; flex-grow: 1; margin-right: 10px">
              <input v-model="search" type="text" placeholder="Pesquisar..." style="width: 100%; box-sizing: border-box" />
              <i class="fas fa-search ticket-search"></i>
            </div>
            <i @click="toggleAll(true)" class="fas fa-check-double icon-action"></i>
            <i @click="toggleAll(false)" class="fas fa-times icon-action"></i>
          </div>
          <div style="margin-top: 15px">
            <div v-for="(c, i) in filteredCustomers" @click="toggleSelect(c, i)" :key="c.id" class="list-form hover">
              <div class="form-data">
                {{ c.name }}
                <span class="form-data-detail" style="display: block">{{ c.login }}</span>
              </div>
              <div class="form-action">
                 <i v-show="c.select" class="fas fa-check icon-action"></i>
              </div>
            </div>
          </div>
          <div class="actions" style="padding: 20px 0 0">
            <button @click="send" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-paper-plane'"></i><span>Enviar</span></button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAllCustomers } from '../api/ticket'
import { send } from '../api/mail'

export default {
  name: 'ticketsResend',

  props: ['show', 'close'],
  data () {
    return {
      loading: false,
      search: '',
      customers: []
    }
  },
  computed: {
    filteredCustomers () {
      return this.customers.filter(x =>
        String(x.name).toLowerCase().includes(this.search.toLowerCase()) ||
        String(x.login).toLowerCase().includes(this.search.toLowerCase()) ||
        // eslint-disable-next-line
        String(x.phone).replace(/[- \(\)]/g, '').includes(this.search.toLowerCase())
      ).filter((x, i) => i < 5)
    }
  },
  async mounted () {
    try {
      const customers = await getAllCustomers(this.show)
      this.customers = customers || []
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    async send () {
      this.loading = true
      try {
        await send(this.customers.filter(x => x.select).map(x => ({
          email: x.login,
          tickets: x.tickets
        })))
        this.close()
      } catch (error) {
        logger.error(error, this)
      }
      this.loading = false
    },
    toggleSelect (customer, i) {
      // customer.select = !customer.select
      // this.$set(this.customers, i, customer)
      // this.customers[i].select = customer.select
      this.customers = this.customers.map(x => {
        x.select = x.id === customer.id ? !x.select : x.select
        return x
      })
    },
    toggleAll (value) {
      this.customers = this.customers.map(x => {
        x.select = value
        return x
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.ticket-search {
  position: absolute;
  top: 10px;
  right: 10px;
  color: $primary-color;
  font-size: 1.5em;
}

.icon-action {
  color: $primary-color;
  font-size: 18px;
  padding: 0 5px;
  cursor: pointer;
  &:hover {
    color: $secondary-color;
  }
}
</style>
